module.exports = __webpack_public_path__ + "fdb70df9a57b8107c3ace7ef92ced178.svg";